var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 30C25.0751 30 30 25.0751 30 19C30 12.9249 25.0751 8 19 8C12.9249 8 8 12.9249 8 19C8 25.0751 12.9249 30 19 30ZM22.645 16.2215V14.8135H24.5162V12.9979H14.5675V14.8135H20.1995V16.2215H14.5675V17.9259H20.1069C20.0081 18.4199 19.8043 18.7781 19.4955 19.0004C19.1868 19.2228 18.7174 19.371 18.0875 19.4451C17.4577 19.5068 16.4819 19.5377 15.1604 19.5377V22.0017C15.1604 23.3479 15.5062 24.3731 16.1979 25.0771C16.8895 25.7811 17.8899 26.1331 19.1991 26.1331C20.4589 26.1331 21.4285 25.8058 22.1078 25.1512C22.7871 24.4842 23.1391 23.527 23.1638 22.2796H20.7553C20.7553 22.8848 20.6318 23.3479 20.3848 23.6691C20.1378 23.9778 19.7364 24.1322 19.1806 24.1322C18.6001 24.1322 18.1864 23.9655 17.9393 23.632C17.7047 23.2985 17.5873 22.8416 17.5873 22.2611V21.2792C19.1435 21.2792 20.3045 21.0136 21.0703 20.4825C21.8484 19.9515 22.3362 19.0992 22.5339 17.9259H24.5162V16.2215H22.645Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/finances.868ba61b1fcf056edb9c94929daad675.svg";
export { ForwardRef as ReactComponent };